<template>
  <img
    :src="$root.logoImg"
    class="demo__Header--logo demo__pointer"
    @click="logoClick"
  />
</template>

<script>
export default {
  methods: {
    logoClick() {
      if (this.$route.path !== "/") {
        this.$router.push("/");
      }
    },
  },
};
</script>
